import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import PageActionBar from 'components/PageActionBar';
import StoreFilters from 'components/Filters/StoreFilters';
import StoreList from './storeList';
import StoreDetails from './storeDetails';
import StoreNew from './storeNew';
import StoreEdit from './storeEdit';
import { navigate, navigateBack, requestWorkroomList,
  resetStoreFilters, setStoreFilters } from 'actionCreators';
import { getRole, getStoreFilters } from '../../../../reducers';
import ui from 'redux-ui';

import contentAreaStyles from 'styles/contentArea';

class Stores extends React.Component {
  static propTypes = {
    location: PropTypes.shape({
      pathname: PropTypes.string,
    }),
    route: PropTypes.shape({
      path: PropTypes.string,
    }),
    navigate: PropTypes.func.isRequired,
    requestWorkroomList: PropTypes.func.isRequired,
    role: PropTypes.string,
    children: PropTypes.node,
    filters: PropTypes.object,
    resetStoreFilters: PropTypes.func,
    setStoreFilters: PropTypes.func,
  }

  constructor(context, props) {
    super(context, props);

    this.toggleFilterDrawer = () => {
      this.setState({ showFilterDrawer: !this.state.showFilterDrawer });
    };
    this.isIndexRoute = () => this.props.location.pathname === this.props.route.path;

    this.addStoreAction = this.addStoreAction.bind(this);
    this.state = {
      showFilterDrawer: false,
    };
  }

  componentDidMount() {
    this.props.requestWorkroomList();
  }

  onSearch = (e, value) => {
    e.preventDefault();
    const filters = { ...this.props.filters };
    filters.query = value;
    this.props.setStoreFilters(filters);
  }

  addStoreAction() {
    this.props.navigate('/stores/new');
  }

  render() {
    const showFiltersDrawer = this.isIndexRoute();
    const searchText = 'Search for a store by name or number...';
    return (
      <div>
        <PageActionBar
          resource="store"
          role={this.props.role}
          hidesAddOnMobile
          showFiltersBtn={showFiltersDrawer}
          addAction={this.addStoreAction}
          title="Store Management"
          searchText={searchText}
          toggleFilters={this.toggleFilterDrawer}
          onSearch={this.onSearch}
        />
        <div className={contentAreaStyles.contentAreaContainer}>
          {this.props.children}
          <StoreFilters
            active={this.state.showFilterDrawer}
            onOverlayClick={this.toggleFilterDrawer}
            handleFilterChange={this.props.setStoreFilters}
            filters={this.props.filters}
            title="Estimators"
            reset={this.props.resetStoreFilters}
          />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    role: getRole(state),
    filters: getStoreFilters(state),
  };
}

export default ui({ key: 'stores', state: { successMessage: '' } })(connect(
  mapStateToProps,
  {
    requestWorkroomList,
    navigate,
    navigateBack,
    resetStoreFilters,
    setStoreFilters,
    getStoreFilters,
  },
)(Stores));

export { StoreList, StoreNew, StoreDetails, StoreEdit };



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/stores/index.jsx